module.exports = __webpack_public_path__ + "rosacea_6_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/rosacea_6_before_tn.jpg
// module id = 1456
// module chunks = 0